<template>
    <index-login-modal>
        <div
            slot="content"
            class="content"
        >
            <div class="input-wrap">
                <div class="title flex">
                    <i>*</i>
                    <span>登录密码</span>
                </div>
                <div class="input-box">
                    <input
                        v-model.trim="params.newPassword"
                        type="password"
                        maxlength="16"
                        placeholder="请输入登录密码"
                        @blur="setPasswordFocus"
                    >
                </div>
                <div
                    v-show="isFoucs1 && !params.newPassword"
                    class="rules flex"
                >
                    <i />
                    <span>请输入密码</span>
                </div>
                <div
                    v-show="isFoucs1 && params.newPassword && params.newPassword.length<8"
                    class="rules flex"
                >
                    <i />
                    <span>密码最少为8位</span>
                </div>
                <div
                    v-show="isFoucs1 && params.newPassword && params.newPassword.length>=8 && params.newPassword.length<=16 && isVaidPwd"
                    class="rules flex"
                    style="width: 500px"
                >
                    <i />
                    <span>密码需包含数字、大写字母、小写字母、特殊字符(!@#$%^&*()_+.)中的两种及以上</span>
                </div>
            </div>
            <div class="input-wrap">
                <div class="title flex">
                    <i>*</i>
                    <span>重复密码 </span>
                </div>
                <div class="input-box">
                    <input
                        v-model.trim="params.password"
                        type="password"
                        maxlength="16"
                        placeholder="请输入重复登录密码"
                        @blur="isFoucs2=true"
                    >
                </div>
               
                <div
                    v-show="isFoucs2 && !params.password"
                    class="rules flex"
                >
                    <i />
                    <span>请重复输入密码</span>
                </div>
                <div
                    v-show="isFoucs2 && params.password && params.newPassword!==params.password"
                    class="rules flex"
                >
                    <i />
                    <span>两次密码输入不一致</span>
                </div>
            </div>
        </div>
        <div slot="foot">
            <el-button
                class="foot-btn"
                type="primary"
                :size="$store.state.element.elBtnSize"
                :loading="isLoading"
                @click="handleSaveBtn"
            >
                设置完毕，进入首页
            </el-button>
        </div>
    </index-login-modal>
</template>
<script>
import indexLoginModal from './indexLoginModal'
import { setPassword } from '@/api/password'
import { getPubKey} from '@/api/login'
import JSEncrypt from 'jsencrypt'
import mixins from './mixins'

export default {
    components:{
        indexLoginModal
    },
    mixins:[mixins],
    data(){
        return {
            isLoading:false,
            isFoucs1:false,
            isFoucs2:false,
            //密码校验
            isVaidPwd:false,  
            params:{
                newPassword:'',
                password:'',
            }
        }
    },
    methods:{
        setPasswordFocus() {
            this.isFoucs1=true
            let newValue = this.params.newPassword
            console.log(33,newValue)
            const hasNumber = /[0-9]/.test(newValue)
            const hasLower = /[a-z]/.test(newValue)
            const hasUpper = /[A-Z]/.test(newValue)
            const hasSpecial = /[!@#$%^&*()_+.]/.test(newValue)
            const typeCount = [hasNumber, hasLower, hasUpper, hasSpecial].filter(Boolean).length
            if (typeCount < 2) {
                this.isVaidPwd = true
            }else {
                this.isVaidPwd = false
            }
        },
        async  handleSaveBtn(){
            this.isFoucs1 = this.isFoucs2 = true;
            if(this.params.newPassword === this.params.password && this.params.password && this.params.password.length>=8 && !this.isVaidPwd){
                this.isLoading = true;
                try {
                    let rsaPassWord = ''
                    let rsaPassWordNew = ''
                    // 对内容进行加密
                    const encryptor = new JSEncrypt()  
                    const res = await getPubKey()
                    if (res.code === 200) {
                        this.params.pubKeyId = res.data.pubKeyId
                        encryptor.setPublicKey(res.data.pubKey)
                        rsaPassWord = encryptor.encrypt(this.params.password)
                        rsaPassWordNew = encryptor.encrypt(this.params.newPassword)
                        console.log(this.params.password)
                        console.log(this.params.newPassword) 
                        console.log(rsaPassWord)
                        console.log(rsaPassWordNew)
                    }
                    let paramsNew = JSON.parse(JSON.stringify(this.params))
                    paramsNew.password = rsaPassWord
                    paramsNew.newPassword = rsaPassWordNew
                    let data = await setPassword(paramsNew);
                    if(data){
                        this.$$message(data.msg);
                        let info = _.cloneDeep(this.loginData)
                        
                        // 密码设置成功 
                        info.hasPassword = true;
                        // 关闭密码弹出框
                        this.$store.commit(this.vuexModeuleName+'/updateStateData',{
                            isPwd:false,
                        })

                        // 继续走鉴权的函数逻辑
                        this.authentication(info);

                    }
                    this.isLoading = false;
                }catch(err){
                    this.isLoading = false;
                    this.$$message('设置密码失败 err:'+err,'error')
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .content{
        padding: 41px 97px 47px 56px;
    }
    .foot-btn{
        float: right;
        padding:8px 12px;
        margin-right: 30px;
        background: rgba(33,84,189,1);
        border-color: rgba(33,84,189,1);
        border-radius: 4px;
        font-size:14px;
        font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-weight:500;
        color:rgba(255,255,255,1);
    }
    .input-wrap{
        position: relative;
        padding-bottom: 35px;
    }
    .input-wrap .title{
        height:20px;
        font-size:14px;
        font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-weight:500;
        line-height:20px;
        color: #202C55;
        margin-bottom: 10px;
        i{
            color:rgba(247,78,20,1);
            margin-right: 4px;
        }
    }
    .input-box{
        background:rgba(255,255,255,1);
        width: 100%;
        border-radius:3px;
        border:1px solid rgba(234,235,239,1);
        padding:6px 15px;
        input{
            height:20px;
            font-size:14px;
            font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
            font-weight:400;
            line-height:20px;
            color: #333;
            width: 100%;
        }
        input::-webkit-input-placeholder { 
            color:rgba(190,194,208,1);
        }
    }
    .rules{
        height:17px;
        font-size:12px;
        font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-weight:400;
        color:rgba(247,78,20,1);
        line-height:17px;
        position: absolute;
        bottom: 13px;
        align-items: center;
        left: 0;
        i{
            background: url('../images/tanhao.png') no-repeat center;
            background-size: cover;
            width: 13px;
            height: 13px;
            display: inline-block;
            margin-left: 16px;
            margin-right: 5px;
        }
    }
</style>